import ably from '../../core/ably'
import parser from '../../core/parser'
import consultationAPI from '../../api/consultation'
import prescriptionAPI from '../../api/customer/prescription'
import labTestsAPI from '../../api/lab_tests'
import alerts from '../../core/alerts'
import moment from 'moment'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/index.css'
import Vue from 'vue'
Vue.use(VueToast)
// import _ from 'lodash'

// State
const state = {
  patientMessages: []
}

// Getters
const getters = {
  getMessages (state, getters, rootState) {
    let consult = rootState.consultation.activeConsults.find(function (ele) {
      return (ele.channelId === rootState.consultation.activeChannelId)
    })
    if (consult) {
      let obj = state.patientMessages.find(function (ele) {
        return (ele.consultationRequestId === consult.consultationRequest.consultationRequestId)
      })
      if (obj) {
        return obj.messages
      }
    }
    return []
  },

  getAllPatientsMessages () {
    return state.patientMessages
  }
}

// Actions
const actions = {
  setUpAllPatientMessages ({ commit, rootState, dispatch }) {
    commit('preSetUp', rootState.consultation.activeConsults)
    consultationAPI.getAllPatientMessages().then(response => {
      if (response.status === 200) {
        commit('setUpAllPatientMessages', {allMessages: response.body.all_messages, activeConsults: rootState.consultation.activeConsults})
      }
    })
  },

  setUpMessages ({commit, rootState, dispatch}, {channelId, customerId, isNewPatient}) {
    let consult = rootState.consultation.activeConsults.find(function (ele) {
      return (ele.channelId === channelId)
    })
    if (consult) {
      let pm = state.patientMessages.find(function (ele) {
        return (ele.channelId === consult.channelId)
      })
      if (!pm) {
        commit('preSetUp', [consult])
      }
      consultationAPI.getMessages(consult.consultationRequest.consultationRequestId).then(response => {
        if (response.status === 200) {
          let messages = response.body.messages
          let patientMsgs = messages.filter(function (ele) {
            return (ele.user && ele.user.type === 'customer')
          })
          let msgs = messages
          if (patientMsgs.length > 0) {
            let patinetLastMsg = patientMsgs[patientMsgs.length - 1]
            ably.updatePresenceEvents(channelId, 'update', { isRead: true, lastReadMessage: patinetLastMsg.uniqueId, deliveredMessage: patinetLastMsg.uniqueId, consultation_request_id: consult.consultationRequest.consultationRequestId })
            commit('setUpMessages', { messages: msgs, customerId: customerId, channelId: channelId, consultationRequestId: consult.consultationRequest.consultationRequestId, lastReceivedMsg: patinetLastMsg.uniqueId, lastReadMsg: patinetLastMsg.uniqueId })
          } else {
            ably.updatePresenceEvents(channelId, 'update', { isRead: true, lastReadMessage: '', deliveredMessage: '', consultation_request_id: consult.consultationRequest.consultationRequestId })
            commit('setUpMessages', { messages: msgs, customerId: customerId, channelId: channelId, consultationRequestId: consult.consultationRequest.consultationRequestId, lastReceivedMsg: '', lastReadMsg: '' })
          }
          if (isNewPatient === true) {
            dispatch('addWelcomeMessage')
          }
        }
      })
    }
  },
  sendUnreadMsgNotification ({ state, commit, rootState, getters }) {
    let customer = rootState.consultation.activeConsults.find(function (ele) {
      return (ele.channelId === rootState.consultation.activeChannelId)
    })
    if (!customer.isOnline) {
      let doctorMessages = getters.getMessages.filter(function (msg) {
        return (msg.user.type === 'doctor')
      })
      let lastMessage = doctorMessages.pop()
      if (lastMessage && lastMessage.status === 'sent') {
        if (doctorMessages.length < 1 || doctorMessages.pop().status === 'read') {
          sessionStorage.setItem('doctor_notification', 0)
        }
        let doctorNotification = sessionStorage.getItem('doctor_notification')
        if (doctorNotification !== '1') {
          consultationAPI.doctorReplyToOfflineCustomer(lastMessage.uniqueId, customer.consultationRequest.consultationRequestId)
          .then(response => {
            if (response.status === 200) {
              sessionStorage.setItem('doctor_notification', 1)
              // console.log(response)
            } else {
            }
          }, response => {
          })
        }
      }
    } else {
      let dNotification = sessionStorage.getItem('doctor_notification')

      if (dNotification === '1') {
        sessionStorage.setItem('doctor_notification', 0)
      }
    }
  },

  send ({ state, commit, dispatch, rootState }, { message, intentName, channelId }) {
    let patient = rootState.consultation.activeConsults.find(function (ele) {
      return (ele.channelId === channelId)
    })
    if (patient) {
      let msg = parser.buildMessage({ 'text': message }, {intentName: intentName, patient: patient, activeCustomerId: rootState.consultation.activeCustomerId})
      commit('add', {message: msg, status: false, consultationRequestId: patient.consultationRequest.consultationRequestId})
      ably.publishMessage(channelId, msg)
    }
  },

  addWelcomeMessage ({ state, commit, rootState }) {
    let patient = rootState.consultation.activeConsults.find(function (ele) {
      return (ele.channelId === rootState.consultation.activeChannelId)
    })

    let msg = parser.buildWelcomeTextMessage({patient: patient, activeCustomerId: rootState.consultation.activeCustomerId})
    let consult = rootState.consultation.activeConsults.find(function (ele) {
      return (ele.channelId === rootState.consultation.activeChannelId)
    })
    if (consult) {
      commit('add', {message: msg, status: false, consultationRequestId: consult.consultationRequest.consultationRequestId})
      ably.publishMessage(rootState.consultation.activeChannelId, msg)
    }
  },

  receive ({ state, commit, rootState, dispatch }, { channelId, message }) {
    let consult = rootState.consultation.activeConsults.find(function (ele) {
      return (ele.channelId === channelId)
    })
    if (consult) {
      let consultationRequestId = consult.consultationRequest.consultationRequestId
      if (message.user && message.user.type === 'customer') {
        commit('add', { message, consultationRequestId })
        alerts.newMessageSound()
        dispatch('updateDeliveredMsg', { channelId, message })
        if (message.intentName === 'file_customer') {
          dispatch('consultation/receivedDocumentUpdate', { channelId, message }, {root: true})
        }
        if (channelId === rootState.consultation.activeChannelId) {
          dispatch('updateReadMsg', { channelId, message })
        }
      }
    }
  },

  resendMessage ({ state, commit, rootState }, message) {
    commit('addResendMessage', { message: message, status: false, channelId: rootState.consultation.activeChannelId })
  },

  deleteMessage ({ state, commit, rootState }, message) {
    commit('deleteMessage', { message: message, channelId: rootState.consultation.activeChannelId })
  },

  sentMsgStatus ({ state, commit, dispatch }, { message, status, channelId }) {
    commit('sentMsgStatus', { message, status, channelId })
    dispatch('sendUnreadMsgNotification')
    let consult = state.patientMessages.find(function (ele) {
      return (ele.channelId === channelId)
    })
    if (consult) {
      let index = state.patientMessages.indexOf(consult)
      let customerMessages = state.patientMessages[index].messages.filter((msg) => msg.user.type === 'customer')
      let timer = customerMessages.length > 1 ? 480000 : 180000
      setTimeout(() => {
        if (state.patientMessages[index]) {
          if (message.uniqueId === state.patientMessages[index].messages.slice(-1)[0].uniqueId) {
            dispatch('consultation/endChat', { status: 'FAILURE', reasons: ['Customer did not respond'], id: channelId }, { root: true })
          }
        }
      }, timer)
    }
  },

  updateDeliveredMsg ({ state, commit }, { channelId, message }) {
    let patient = state.patientMessages.find(function (ele) {
      return (ele.channelId === channelId)
    })
    if (patient) {
      ably.updatePresenceEvents(channelId, 'update', { isDelivered: true, lastReadMessage: patient.lastReadMsg, deliveredMessage: message.uniqueId, consultation_request_id: patient.consultationRequestId })
      commit('updateLastReceivedMsg', { channelId: channelId, id: message.uniqueId })
    }
  },

  updateReadMsg ({ state, commit }, { channelId, message }) {
    let patient = state.patientMessages.find(function (ele) {
      return (ele.channelId === channelId)
    })
    if (patient) {
      ably.updatePresenceEvents(channelId, 'update', { isRead: true, lastReadMessage: message.uniqueId, deliveredMessage: patient.lastReceivedMsg, consultation_request_id: patient.consultationRequestId })
      commit('updateLastReadMsg', { channelId: channelId, id: message.uniqueId })
    }
  },

  receiveCustomerLastDelivered ({ commit, state }, { channelId, deliveredMessage }) {
    commit('messageDelivered', { channelId, deliveredMessage })
  },

  receiveCustomerLastRead ({ commit, state }, { channelId, lastReadMessage }) {
    commit('messageRead', { channelId, lastReadMessage })
  },

  documentUploadProgress ({ state, commit, dispatch, rootState }, {file, channelId}) {
    file.uniqueId = 'temp'
    commit('addFileUploadMessage', { message: file, status: false, channelId: channelId })
    dispatch('loader/setLoader', {loading: false, componentKey: null}, { root: true })
  },

  uploadDocument ({ state, commit, rootState, dispatch }, { fileList }) {
    let patient = rootState.consultation.activeConsults.find(function (ele) {
      return (ele.channelId === rootState.consultation.activeChannelId)
    })
    let consultationId = rootState.consultation.consultationId
    let activeCustomerId = rootState.consultation.activeCustomerId

    let formData = parser.buildFileData(fileList, {patient: patient, consultationId: consultationId, activeCustomerId: activeCustomerId})
    let file = parser.buildTempFileData(fileList[0])
    // let customerId = rootState.consultation.activeCustomerId
    let channelId = rootState.consultation.activeChannelId
    commit('addFileUploadMessage', { message: file, status: false, channelId: channelId })
    consultationAPI.uploadFile(formData, file, channelId).then(response => {
      if (response.status === 200) {
        let msg = parser.buildDocumentMessage({
          url: response.body.file_url[0],
          id: response.body.id,
          fileName: fileList[0].name,
          type: 'document',
          intentName: 'file_attachment'
        })
        if (ably.publishMessage(channelId, msg)) {
          msg.progress = 100
          msg.state = 'uploaded'
          commit('addFileUploadMessage', { message: msg, status: true, channelId: channelId })
          dispatch('consultation/receivedDocumentUpdate', { channelId: channelId, message: msg }, {root: true})
        } else {
          msg.progress = 100
          msg.state = 'uploaded'
          commit('addFileUploadMessage', { message: msg, status: false, channelId: channelId })
          dispatch('consultation/receivedDocumentUpdate', { channelId: channelId, message: msg }, {root: true})
        }
      }
    }).catch(function (e) {
      file.state = 'reload'
      commit('addFileUploadMessage', { message: file, status: true, channelId: channelId })
    })
  },

  sendPrescription ({ commit, state, dispatch, rootState }, { data }) {
    let date = Date.now()
    let file = parser.buildTempFileData({ name: 'rx_' + date + '.pdf' })
    file.prescription = data.prescription
    // let customerId = rootState.consultation.activeCustomerId
    let activeChannelId = rootState.consultation.activeChannelId
    let activeCustomerId = rootState.consultation.activeCustomerId
    let patient = rootState.consultation.activeConsults.find(function (ele) {
      return (ele.channelId === rootState.consultation.activeChannelId)
    })
    commit('addFileUploadMessage', { message: file, status: true, channelId: activeChannelId })
    prescriptionAPI.createPrescription(file, 'send', activeChannelId).then(response => {
      if (response.status === 200) {
        let msg = parser.buildDocumentMessage({
          url: response.body.prescription_url,
          id: response.body.id,
          fileName: response.body.prescription_name,
          type: 'prescription',
          intentName: 'file_prescription',
          medications: response.body.medications,
          activeChannelId: activeChannelId,
          activeCustomerId: activeCustomerId,
          patient: patient,
          activeConsultationId: patient.consultation.consultationId,
          activeConsultationRequestId: patient.consultationRequest.consultationRequestId
        })
        if (ably.publishMessage(activeChannelId, msg)) {
          msg.progress = 100
          msg.state = 'uploaded'
          commit('addFileUploadMessage', { message: msg, status: true, channelId: activeChannelId })
        } else {
          msg.progress = 100
          msg.state = 'uploaded'
          commit('addFileUploadMessage', { message: msg, status: false, channelId: activeChannelId })
        }
      }
    }).catch(function (e) {
      file.state = 'reload'
      commit('addFileUploadMessage', { message: file, status: true, channelId: activeChannelId })
    })
  },

  sendRecommendedTests ({ commit, state, dispatch, rootState }, { data, consultationType }) {
    let patient = rootState.consultation.activeConsults.find(function (ele) {
      return (ele.channelId === rootState.consultation.activeChannelId)
    })

    let consult = null
    let msg = null

    if (consultationType === 'Chat') {
      msg = parser.buildMessage({ 'recommended_tests': data.recommended_tests }, {intentName: 'recommended_tests', patient: patient, activeCustomerId: rootState.consultation.activeCustomerId})
      consult = rootState.consultation.activeConsults.find(function (ele) {
        return (ele.channelId === rootState.consultation.activeChannelId)
      })
    } else if (consultationType === 'OfflineConsults') {
      consult = rootState.offlineConsultation.activeOfflineConsults.find(function (ele) {
        return (ele.consultation.consultationId === data.consultation_id)
      })
    }
    if (consult) {
      labTestsAPI.storeRecommendedTests({consultation_id: data.consultation_id || consult.consultation.consultationId, package_ids: data.package_ids}).then(response => {
        Vue.$toast.open({
          message: `Lab tests successfully sent!`,
          type: 'success',
          position: 'bottom-right',
          queue: false
        })
        if (consultationType === 'Chat') {
          commit('add', {message: msg, status: false, consultationRequestId: consult.consultationRequest ? consult.consultationRequest.consultationRequestId : null})
          dispatch('consultation/updateRecommendedTests', response.body.recommended_tests, {root: true})
          ably.publishMessage(rootState.consultation.activeChannelId, msg)
        }
      }).catch(function (e) {
        console.log(e)
      })
    }
  },

  removeChat ({ commit }, {channelId}) {
    commit('removeChat', {channelId})
  }
}

// Mutations
const mutations = {
  preSetUp (state, activeConsults) {
    for (let i = 0; i < activeConsults.length; i++) {
      let chiefComp = activeConsults[i].consultationRequest.chiefComplaint
      if (!chiefComp) {
        chiefComp = 'Patient did not answer this.'
      }
      let timeInMilliSeconds = new Date(activeConsults[i].consultationRequest.date).getTime()
      if (isNaN(timeInMilliSeconds)) {
        let tempDate = moment(new Date()).format('DD MMM YYYY')
        let tempDateTime = tempDate + ' ' + activeConsults[i].consultationRequest.date
        timeInMilliSeconds = new Date(tempDateTime).getTime()
      }
      let topMsgs = [
        { payload: { text: 'Please let us know your health issue' }, status: 'read', uniqueId: timeInMilliSeconds, timestamp: timeInMilliSeconds, intentName: 'incoming_text', user: { type: 'doctor' } },
        { payload: { text: chiefComp }, status: 'read', uniqueId: timeInMilliSeconds, timestamp: timeInMilliSeconds, intentName: 'incoming_text', user: { type: 'customer' } }
      ]
      state.patientMessages.push({
        messages: topMsgs,
        customerId: activeConsults[i].customerId,
        channelId: activeConsults[i].channelId,
        consultationRequestId: activeConsults[i].consultationRequest.consultationRequestId,
        lastReceivedMsg: '',
        lastReadMsg: '',
        newMessages: 0
      })
    }
  },
  setUpAllPatientMessages (state, {allMessages, activeConsults}) {
    for (let i = 0; i < activeConsults.length; i++) {
      let obj = allMessages.find(function (ele) {
        return (ele.consultation_request_id === activeConsults[i].consultationRequest.consultationRequestId)
      })
      if (obj) {
        let objAlready = state.patientMessages.find(function (ele) {
          return (ele.channelId === activeConsults[i].channelId)
        })
        if (objAlready) {
          for (let i = 0; i < obj.messages.length; i++) {
            let mi = objAlready.messages.findIndex(function (ele) {
              return (parseInt(ele.uniqueId) === parseInt(obj.messages[i].uniqueId))
            })
            if (mi < 0) {
              objAlready.messages.push(obj.messages[i])
            }
          }
          state.patientMessages[i].messages = objAlready.messages
          state.patientMessages[i].lastReceivedMsg = objAlready.lastReceivedMsg
          state.patientMessages[i].lastReadMsg = objAlready.lastReadMsg
        } else {
          state.patientMessages.push({
            messages: obj.messages,
            customerId: activeConsults[i].customerId,
            channelId: activeConsults[i].channelId,
            consultationRequestId: activeConsults[i].consultationRequest.consultationRequestId,
            lastReceivedMsg: '',
            lastReadMsg: '',
            newMessages: 0
          })
        }
      }
    }
  },

  setUpMessages (state, { messages, customerId, channelId, consultationRequestId, lastReceivedMsg, lastReadMsg }) {
    let index = state.patientMessages.findIndex(function (ele) {
      return (ele.channelId === channelId)
    })
    if (index > -1) {
      if (state.patientMessages[index].messages.length > 2) {
        let topMessages = state.patientMessages[index].messages.slice(0, 2)
        messages = topMessages.concat(messages)
        let pm = state.patientMessages[index].messages.filter(function (ele) {
          return (ele.user && ele.user.type === 'doctor')
        })
        for (let i = 2; i < pm.length; i++) {
          let mi = messages.findIndex(function (ele) {
            return (parseInt(ele.uniqueId) === parseInt(pm[i].uniqueId))
          })
          if (mi < 0) {
            messages.push(pm[i])
          }
        }
      } else {
        messages = state.patientMessages[index].messages.concat(messages)
      }
      state.patientMessages[index].messages = messages
      state.patientMessages[index].lastReceivedMsg = lastReceivedMsg
      state.patientMessages[index].lastReadMsg = lastReadMsg
      state.patientMessages[index].newMessages = 0
    } else {
      state.patientMessages.push({ messages: messages, customerId: customerId, channelId: channelId, consultationRequestId: consultationRequestId, lastReceivedMsg: lastReceivedMsg, lastReadMsg: lastReadMsg, newMessages: 0 })
    }
  },

  add (state, { message, status, consultationRequestId }) {
    let obj = state.patientMessages.find(function (ele) {
      return (ele.consultationRequestId === consultationRequestId)
    })
    let index = state.patientMessages.indexOf(obj)
    if (obj) {
      if (status === true) {
        // doctor side messages
        message.status = 'sent'
      } else if (status === false) {
        message.status = null
      }
      let messages = obj.messages
      let m = messages.find(function (ele) {
        return (ele.uniqueId === message.uniqueId)
      })
      let messageIndex = messages.indexOf(m)
      if (messageIndex === -1) {
        state.patientMessages[index].messages.push(message)
      }
    }
  },

  addFileUploadMessage (state, { channelId, message, status }) {
    let consult = state.patientMessages.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.patientMessages.indexOf(consult)
    if (index > -1) {
      message.status = 'sent'
      let messages = state.patientMessages[index].messages
      let m = messages.find(function (ele) {
        return (ele.uniqueId === message.uniqueId)
      })
      let messageIndex = messages.indexOf(m)
      if (messageIndex === -1) {
        if (message.uniqueId) {
          state.patientMessages[index].messages.splice(messages.length - 1, 1, message)
        } else {
          state.patientMessages[index].messages.push(message)
        }
      } else {
        state.patientMessages[index].messages.splice(messages.length - 1, 1, message)
      }
    }
  },

  addResendMessage (state, { channelId, message, status }) {
    let consult = state.patientMessages.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.patientMessages.indexOf(consult)
    if (index > -1) {
      let messages = state.patientMessages[index].messages
      let m = messages.find(function (ele) {
        return (ele.uniqueId === message.uniqueId)
      })
      let messageIndex = messages.indexOf(m)
      if (messageIndex > -1) {
        state.patientMessages[index].messages.splice(messageIndex, 1)
      }
      message.uniqueId = new Date().getTime()
      delete message.status
      ably.publishMessage(channelId, message)
      if (status === true) {
        message.status = 'sent'
      } else if (status === false) {
        message.status = null
      }
      state.patientMessages[index].messages.push(message)
    }
  },

  deleteMessage (state, { channelId, message }) {
    let consult = state.patientMessages.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.patientMessages.indexOf(consult)
    if (index > -1) {
      let messages = state.patientMessages[index].messages
      let m = messages.find(function (ele) {
        return (ele.uniqueId === message.uniqueId)
      })
      let messageIndex = messages.indexOf(m)
      if (messageIndex > -1) {
        state.patientMessages[index].messages.splice(messageIndex, 1)
      }
    }
  },

  sentMsgStatus (state, { message, status, channelId }) {
    let consult = state.patientMessages.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.patientMessages.indexOf(consult)
    if (index > -1) {
      let messages = state.patientMessages[index].messages
      let m = messages.find(function (ele) {
        return (ele.uniqueId === message.uniqueId)
      })
      let messageIndex = messages.indexOf(m)
      if (messageIndex > -1) {
        if (status === true && state.patientMessages[index].messages[messageIndex].status === null) {
          state.patientMessages[index].messages[messageIndex].status = 'sent'
        } else if (status === false) {
          state.patientMessages[index].messages[messageIndex].status = null
        }
      }
    }
  },

  updateLastReceivedMsg (state, { channelId, id }) {
    let consult = state.patientMessages.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.patientMessages.indexOf(consult)
    if (index > -1) {
      state.patientMessages[index].lastReceivedMsg = id
      state.patientMessages[index].newMessages += 1
    }
  },

  updateLastReadMsg (state, { channelId, id }) {
    let consult = state.patientMessages.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.patientMessages.indexOf(consult)
    if (index > -1) {
      state.patientMessages[index].lastReadMsg = id
      state.patientMessages[index].newMessages = 0
    }
  },

  messageDelivered (state, { channelId, deliveredMessage }) {
    let consult = state.patientMessages.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.patientMessages.indexOf(consult)
    if (index > -1) {
      let msgs = state.patientMessages[index].messages
      for (let i = 0; i < msgs.length; i++) {
        if (msgs[i].user && msgs[i].user.type === 'doctor' && parseInt(msgs[i].uniqueId) <= parseInt(deliveredMessage) && (msgs[i].status === null || msgs[i].status === 'sent')) {
          state.patientMessages[index].messages[i].status = 'delivered'
        }
      }
    }
  },

  messageRead (state, { channelId, lastReadMessage }) {
    let consult = state.patientMessages.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.patientMessages.indexOf(consult)
    if (index > -1) {
      let msgs = state.patientMessages[index].messages
      for (let i = 0; i < msgs.length; i++) {
        if (msgs[i].user && msgs[i].user.type === 'doctor' && parseInt(msgs[i].uniqueId) <= parseInt(lastReadMessage) && (msgs[i].status === null || msgs[i].status === 'sent' || msgs[i].status === 'delivered')) {
          state.patientMessages[index].messages[i].status = 'read'
        }
      }
    }
  },

  removeChat (state, {channelId}) {
    let consult = state.patientMessages.find(function (ele) {
      return (ele.channelId === channelId)
    })
    let index = state.patientMessages.indexOf(consult)
    if (index > -1) {
      state.patientMessages.splice(index, 1)
    }
  },

  reset (state) {
    state = {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/message.js